
/* Application entry-point */

/* Import Libraries */
import 'jquery-mention';
import Translator from './lib/translator.js';

/* Import CSS */
import '@platsoft/ui-bs3/dist/ui-bs3.css';
import '@platsoft/ui-ps-payment-approval/dist/grape_payment_approval.css';
import '../static/lib/css/app.css';
import '../static/lib/css/bootstrap.css';
import '../static/lib/css/introjs.css';

/* Import local code */
import pages from './pages/index.js';
import dialogs from './dialogs/index.js';
import components from './components/index.js';
import appcaches from './caches/index.js';

import bindingHandlers from './bindingHandlers/index.js';

import GrapeUIPlugin from './lib/Plugin.js';

import * as Utils from './lib/savanna_utils.js';
import * as GrapeSettings from './lib/grape_settings.js';
import * as SystemEvents from './lib/system_events.js';
import tr from './lib/default-translator.js';

import translated_pages from './translations/index.js';

import * as savanna_functions from '../static/lib/js/savanna_functions/savanna_module_v1.0.js';

/* Define default routes */
const default_routes = {
	'admin': '/employee/list/0',
	'manager': '/employee/redirect/',
	'employee': '/employee/redirect/',
	'guest': '/ui/login',
	'unverified_user': '/employee/redirect/',
	'accountant': '/employee/redirect/',
	'external_manager': '/employee/redirect/'
};

window.translator = new Translator();
// Iterate over the properties of savanna_functions and attach each one to the window object
Object.keys(savanna_functions).forEach(functionName => {
	window[functionName] = savanna_functions[functionName];
});

window.translated_pages = { ...translated_pages, ...window.payment_translated_pages};

if (localStorage.getItem('user_language_setting'))
	window.currentLanguageCode = localStorage.getItem('user_language_setting');
else
	window.currentLanguageCode = 'en';

// For current page title component
window.current_page_title = ko.observable(localStorage.getItem('current_page_title') || '');
window.current_page_title.subscribe((newValue) => {
	localStorage.setItem('current_page_title', newValue);
});

document.addEventListener('DOMContentLoaded', () =>  {
	/* Setup app */
	//Grape.config.debug = true;
	Grape.config.default_routes = default_routes;
	window.tr = tr;

	// Register bindingHandlers
	bindingHandlers.forEach((handler) => {
		ko.bindingHandlers[handler.name] = handler.handler;
	});

	window.Grape.pages.registerPages(pages);
	window.Grape.dialog.registerDialogs(dialogs);
	window.Grape.cache.registerCaches(appcaches);
	window.Grape.component.registerComponents(components);
	window.Grape.plugins.register(GrapeUIPlugin);

	/* Start app */
	Grape.init();
});

Grape.on('after_logout', function (e) {
	SystemEvents.destroy_user();
});

// called once a reroute is triggered
Grape.on('route_triggered', async function (e) {
	Utils.hideLoader();

	let wizard = await GrapeSettings.wizard();
	if (wizard && Grape.currentSession)
		Grape.navigate('/wizard/wizard_start');
});
